import config from '../config';

export const buildPublicUrl = (path) => `${config.publicApiBaseUrl}${path}`;

export async function readPublicJson(path) {
  const response = await fetch(buildPublicUrl(path));

  if (!response.ok) {
    throw new Error(`Public API request failed: ${path}`);
  }

  return response.json();
}

export const readPublicEpisodes = () => readPublicJson('/v1/public/episodes');
export const readPublicEpisode = (episodeId) => readPublicJson(`/v1/public/episodes/${episodeId}`);
export const readPublicContacts = () => readPublicJson('/v1/public/contacts');
export const readPublicSiteConfig = () => readPublicJson('/v1/public/site-config');
export const readPublicSocial = () => readPublicJson('/v1/public/social');
export const readPublicContact = () => readPublicJson('/v1/public/contact');
export const readPublicSupporters = () => readPublicJson('/v1/public/supporters');
